import { render, staticRenderFns } from "./SupervisorsManagement.vue?vue&type=template&id=010a4030&"
import script from "./SupervisorsManagement.vue?vue&type=script&lang=js&"
export * from "./SupervisorsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports